import { format } from "date-fns";

export const getUTC = (date: string) => {
  if (!date) {
    return new Date(Number.NaN);
  }

  const timeZoneOffsetMs = new Date(date).getTimezoneOffset() * 60 * 1000;
  const utcDate = new Date(new Date(date).getTime() + timeZoneOffsetMs);

  return utcDate;
};

const options = {
  timeZone: "America/New_York",
};

export const getEST = (date: string | Date) => {
  if (!date) {
    return "";
  }

  const dateEst = new Date(date);

  if (Number.isNaN(dateEst.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat("en-US", options).format(dateEst);
};

export const formatInsightsHubDisplayDate = (date: string): string => {
  const est = getEST(date);

  if (!est) {
    return "";
  }

  const parsed = Date.parse(est);

  if (Number.isNaN(parsed)) {
    return "";
  }

  return format(parsed, "MMM d, yyyy");
};

export const formatInsightsHubArticleDisplayDate = (publishDate: string): string => {
  return formatInsightsHubDisplayDate(publishDate);
};
